import React from 'react';

interface Props {
  searchTerm: string;
  setSearchTerm: (value: string, any) => void;
}

const SearchClearButton = ({ searchTerm, setSearchTerm }: Props) => {
  if (!searchTerm) {
    return <></>;
  }

  return (
    <button onClick={() => setSearchTerm('', { shouldClearFilters: false })} className="search-header__clear-button">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.9007 14.479L15.7407 14.319C15.6707 14.249 15.5807 14.209 15.4807 14.209H14.4407C14.3107 14.209 14.2207 14.289 14.2207 14.429V15.469C14.2207 15.579 14.2607 15.659 14.3307 15.729L14.4907 15.889L26.0307 27.429L27.4407 26.019L15.9007 14.479Z" fill="black"/>
        <path d="M13.41 11.999L1.91 0.499023L0.5 1.90902L12.04 13.449L12.2 13.609C12.27 13.679 12.36 13.719 12.46 13.719H13.5C13.63 13.719 13.72 13.639 13.72 13.499V12.459C13.72 12.349 13.68 12.269 13.61 12.199L13.41 11.999Z" fill="black"/>
        <path d="M13.51 14.2188H12.47C12.36 14.2188 12.28 14.2587 12.21 14.3287L12.05 14.4887L0.5 26.0288L1.91 27.4388L13.45 15.8987L13.61 15.7387C13.68 15.6687 13.72 15.5787 13.72 15.4787V14.4387C13.72 14.3087 13.64 14.2188 13.5 14.2188H13.51Z" fill="black"/>
        <path d="M14.4407 13.719H15.4807C15.5907 13.719 15.6707 13.679 15.7407 13.609L15.9407 13.409L27.4407 1.90902L26.0307 0.499023L14.4907 12.039L14.3307 12.199C14.2607 12.269 14.2207 12.359 14.2207 12.459V13.499C14.2207 13.629 14.3007 13.719 14.4407 13.719Z" fill="black"/>
      </svg>
    </button>
  );
};

export default SearchClearButton;
